module.exports = __webpack_public_path__ + "img/scene2.fba2f42c.svg";